import theme from "@theme/";
import styled from "styled-components";

// const ChatContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   height: 75vh;
//   margin: 0 auto;
//   background-color: #f6f6f6;
//   font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
//     "Ubuntu", sans-serif;
// `;

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  // height: 100%;
  max-height: 80vh;
  min-height: 50vh;
  background-color: #f6f6f6;

  @media (max-width: 768px) {
    height: 100vh;
  }
`;

const Header = styled.div`
  // background-color: ${theme.colors.themeColor};
  background: ${theme.gradient.themeGradient};
  border-radius: ${(props) => (props.border ? "8px 8px 0 0" : "0")};
  color: white;
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

// const HeaderTitle = styled.h1`
//   margin: 0;
//   font-size: 18px;
//   font-weight: 500;
// `;

const HeaderTitle = styled.h1`
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: 2px solid white;
  border-radius: 50%;
  width: 36px;
  height: 36px;

  color: white;
  font-size: 20px;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease-in-out;

  /* NEW: subtle glow shadow */
  box-shadow: 0 4px 10px rgba(255, 255, 255, 0.25);

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 6px 16px rgba(255, 255, 255, 0.35);
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.95);
    box-shadow: 0 2px 6px rgba(255, 255, 255, 0.2);
  }
`;

const MessagesArea = styled.div`
  flex: 1;
  overflow-y: auto;
  // padding: 24px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  min-height: 0;

  @media (max-width: 768px) {
    padding: 12px;
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
`;

const EmptyStateText = styled.h2`
  font-size: 15px;
  font-weight: 400;
  color: #333;
  margin: 0;
`;

const MessageBubble = styled.div`
  display: inline-block;
  width: fit-content;
  max-width: 100%;
  background-color: #fffdf5;
  padding: 16px 8px 16px 15px;
  border-radius: 16px;
  word-break: break-word;
  overflow-wrap: anywhere;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const AnswerWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const QuestionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 12px 0px;
`;

const QuestionText = styled.div`
  display: inline-block;
  background-color: #ffffff;
  padding: 10px 12px;
  border-radius: 16px;
  font-size: 14px;
  max-width: 70%;
  word-break: break-word;
`;

const ResponseTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
`;

const ResponseText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  max-width: 100%;
  overflow-wrap: anywhere;

  pre {
    max-width: 100%;
    overflow-x: auto;
  }

  code {
    word-break: break-word;
  }
`;

const EvidenceText = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 12px 0 8px 0;
`;

const BulletList = styled.ul`
  margin: 0;
  padding-left: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #555;

  li {
    margin-bottom: 8px;
  }
`;

const InputContainer = styled.div`
  padding: 12px 16px;
  background-color: #f5f5f5;
  flex-shrink: 0;

  /* Mobile safe area */
  @media (max-width: 768px) {
    padding: 8px 12px;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%; /* 🔥 REQUIRED */
  min-width: 0; /* 🔥 FLEX BUG FIX */
  background-color: white;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 20px;
  padding: 6px 6px 6px 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

// const Input = styled.input`
//   flex: 1;
//   border: none;
//   outline: none;
//   font-size: 16px;
//   padding: 12px 8px;
//   background: transparent;

//   &::placeholder {
//     color: #333;
//   }
// `;

const Input = styled.input`
  flex: 1;
  min-width: 0; /* 🔥 REQUIRED */
  border: none;
  outline: none;
  font-size: 16px; /* prevents iOS zoom */
  padding: 10px 8px;
  background: transparent;
  line-height: 1.4;

  &::placeholder {
    color: #555;
  }
`;

const SendButton = styled.button`
  background-color: ${theme.colors.themeColor};
  border: none;
  border-radius: 50%;

  /* 🔥 Responsive size */
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    opacity 0.2s ease;
  flex-shrink: 0;

  /* Mobile touch-friendly */
  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
  }

  &:hover {
    background-color: ${theme.colors.themeColor};
  }

  &:disabled {
    background-color: #cccccc;
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const SendIcon = styled.span`
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 12px solid white;
  margin-left: 3px;
`;

/* Typing bubble for assistant while waiting */
const TypingWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 6px 0;
`;

const TypingBubble = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #fffdf5;
  padding: 10px 16px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  max-width: 60%;
`;

/* three animated dots */
const Dot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #c7c7c7;
  border-radius: 50%;
  opacity: 0.9;
  transform: translateY(0);
  animation: dot 1s infinite ease-in-out;
  &:nth-child(2) {
    animation-delay: 0.15s;
  }
  &:nth-child(3) {
    animation-delay: 0.3s;
  }

  @keyframes dot {
    0% {
      transform: translateY(0);
      opacity: 0.6;
    }
    50% {
      transform: translateY(-6px);
      opacity: 1;
    }
    100% {
      transform: translateY(0);
      opacity: 0.6;
    }
  }
`;

const JumpToBottom = styled.button`
  position: absolute;
  bottom: 80px;
  right: 16px;
  background: #1976d2;
  color: white;
  border-radius: 16px;
  padding: 6px 12px;
`;

const CopyWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
`;

const CopyButton = styled.button`
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    color: #111827;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// const RefreshButton = styled.button`
//   background: transparent;
//   border: none;
//   cursor: pointer;
//   padding: 6px;
//   border-radius: 50%;
//   transition: background 0.2s ease;

//   &:hover {
//     background: #f0f4ff;
//   }

//   svg {
//     font-size: 18px;
//     color: #4a6cf7;
//   }
// `;

const RefreshButton = styled.button`
  padding: 6px 14px;
  border-radius: 10px;
  border: 1px solid ${theme.colors.white};

  font-size: 12px;
  font-weight: 600;

  color: #ffffff;
  background: ${theme.gradient.themeGradient};

  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.35);

  cursor: pointer;
  transition: all 0.18s ease-in-out;

  &:hover {
    transform: translateY(-1px);
    background: ${theme.gradient.themeGradient};
    box-shadow: 0 6px 16px rgba(59, 130, 246, 0.45);
  }

  &:active {
    transform: scale(0.96);
  }
`;

const SC = {
  ChatContainer,
  Header,
  HeaderTitle,
  CloseButton,
  MessagesArea,
  EmptyState,
  EmptyStateText,
  MessageBubble,
  QuestionText,
  ResponseTitle,
  ResponseText,
  EvidenceText,
  BulletList,
  InputContainer,
  InputWrapper,
  Input,
  SendButton,
  SendIcon,
  QuestionWrapper,
  AnswerWrapper,
  TypingWrapper,
  TypingBubble,
  Dot,
  JumpToBottom,
  CopyWrapper,
  CopyButton,
  HeaderActions,
  RefreshButton,
};

export default SC;
